import { AccountVariationsConfig, useAccount } from '@nizza/core';
import { useEffect, useState } from 'react';

export const useVariationsConfig = () => {
  const { account, isLoading } = useAccount();
  const [variationsConfig, setVariationsConfig] =
    useState<AccountVariationsConfig>();

  useEffect(() => {
    const variationsConfig = account?.variationsConfig;

    if (!variationsConfig) return;

    const selected = Array.isArray(variationsConfig?.selected);
    const omitted = Array.isArray(variationsConfig?.omitted);

    if (selected || omitted) {
      setVariationsConfig(variationsConfig);
    }
  }, [account]);

  return {
    variationsConfig,
    isLoading,
  };
};

export default useVariationsConfig;
